import * as XLSX from "xlsx";
import dayjs from "dayjs";

export const exportMonthEndSaleSummaryExcel = (data, dateRange) => {
  if (!data || data.length === 0) return;

  // Prepare Excel data
  const excelData = data.map((item) => ({
    "Year": item.sysYear,
    "Month": item.sysMonth,
    "Sales Date": dayjs(item.salesDate).format("YYYY-MM-DD"),
    "New Starts": item.newStarts,
    "New Recruits": item.newRecruits,
    "New Recruits Orders Count": item.dailyNewRecruitsOrderCount,
    "New Recruits Sales Total": item.dailyNewRecruitsSales,
    "Sales Force": item.salesForce,
    "Inactive Consultants Count": item.inactiveConsultants,
    "Reactive Consultants Count": item.reactiveConsultants,
    "Orders Placed Consultants Count": item.dailyOrderConsultants,
    "BP Orders Count": item.dailyBPOrderCount,
    "Daily Sales": item.dailysales,
    "Cumulative Sales": item.cumSales,
    "Daily BP": item.dailyBp,
    "Cumulative BP": item.cumBp,
  }));

  // Create sheet manually
  const sheet = XLSX.utils.json_to_sheet([]);

  // Add title
  XLSX.utils.sheet_add_aoa(sheet, [["Month-End Sale Summary"]], { origin: "A1" });

  // Add table headers + data starting from A3
  XLSX.utils.sheet_add_json(sheet, excelData, { origin: "A3", skipHeader: false });

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, "Month-End Sale Summary");

  // Download
  const fileName = `MonthEndSaleSummary_${dayjs().format("YYYYMMDD_HHmmss")}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};
